const sideMenuActionTypes = {
  TOGGLE_SIDENAV: "TOGGLE_SIDENAV",
  SET_SIDE_NAVIGATION_MENU: "SET_SIDE_NAVIGATION_MENU",
  SIGNOUT_SUCCESS: "SIGNOUT_SUCCESS",
};

export default sideMenuActionTypes;
